import React, { FC, useState, useEffect } from "react";
import { LandingTopNavbar } from "components/landing/landing-top-navbar/landing-top-navbar";

export const LandingTopNavbarContainer: FC = ({ basePath }: any) => {
  const [isFloating, setIsFloating] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsFloating(window.scrollY > 30);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMobileMenuClick = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <LandingTopNavbar
      basePath={basePath}
      isFloating={isFloating}
      isMobileMenuOpen={isMobileMenuOpen}
      onMobileMenuButtonClick={handleMobileMenuClick}
      onMenuLinkClick={handleMobileMenuClick}
    />
  );
};
